import React from 'react'
import { CircularProgress, Box, Typography } from '@mui/material'
import { TypographyVariants } from '@/app/styles/themes/typography'
import { useTheme } from '@mui/material/styles'

interface SpinnerStylingProps {
	spinnerSize?: number
	spinnerThickness?: number
	gradientStartColor?: string
	gradientEndColor?: string
}

interface LoadingComponentProps {
	title?: string
	subtitle?: string
	spinnerProps?: SpinnerStylingProps
	message?: string
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({
	title,
	subtitle,
	message,
	spinnerProps = {},
}) => {
	const theme = useTheme()
	const styling = {
		spinnerSize: 56,
		spinnerThickness: 4,
		gradientStartColor: theme.palette.surface.brand.secondary,
		gradientEndColor: theme.palette.surface.neutral.t1Base,
		...spinnerProps,
	}
	const topMargin = 20

	return (
		<Box display="flex" flexDirection="column" alignItems="center">
			<svg width={0} height={0}>
				<defs>
					<linearGradient
						id="spinner_gradient"
						x1="0%"
						y1="0%"
						x2="0%"
						y2="100%"
						data-testid="spinner-gradient"
					>
						<stop offset="0%" stopColor={styling.gradientStartColor} />
						<stop offset="100%" stopColor={styling.gradientEndColor} />
					</linearGradient>
				</defs>
			</svg>
			<CircularProgress
				size={styling.spinnerSize}
				thickness={styling.spinnerThickness}
				sx={{
					'svg circle': {
						stroke: 'url(#spinner_gradient)',
						strokeLinecap: 'round',
					},
				}}
			/>
			<Box height={topMargin} />
			{title && (
				<Typography
					variant={TypographyVariants.mediumSemiBold}
					sx={{
						marginTop: topMargin,
					}}
				>
					{title}
				</Typography>
			)}
			{subtitle && (
				<Typography
					variant={TypographyVariants.smallRegular}
					sx={{
						pt: 2,
					}}
				>
					{subtitle}
				</Typography>
			)}
			{message && (
				<Typography
					variant={TypographyVariants.smallRegular}
					sx={{
						pt: 2,
					}}
				>
					{message}
				</Typography>
			)}
		</Box>
	)
}

export default LoadingComponent
